import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const equipmentObject = z.object({
  id: z.string().uuid(),
  title: z.string().max(255),
  type: z.string().max(64),
  plate: z.string().max(20).nullish(),
  patrimonyNumber: z.string().max(64),
  observation: z.string().nullish(),
  sourceFilter: z.string().nullish(),
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type EquipmentType = z.infer<typeof equipmentObject>

export const propertyMap = {
  id: sql`equipment.id`,
  title: sql`equipment.title`,
  type: sql`equipment.type`,
  plate: sql`equipment.plate`,
  patrimonyNumber: sql`equipment.patrimony_number`,
  observation: sql`equipment.observation`,
  sourceFilter: sql`equipment.source_filter`,
  clientId: sql`equipment.client_id`,
  insertUserId: sql`equipment.insert_user_id`,
  editUserId: sql`equipment.edit_user_id`,
  createdAt: sql`equipment.created_at`,
  updatedAt: sql`equipment.updated_at`,
  deletedAt: sql`equipment.deleted_at`,
}
